export function convertQueryToParams<T>(queryItem: T): string {
    return queryItem ? `?${getKey<T>(queryItem).join('&')}` : '';
}

function getKey<T>(item: T, keys: string[] = []): string[] {
    const result = [];
    for (const key of Object.keys(item)) {
        if (item[key] instanceof Array) {
            result.push(`${keys.join('.')}${keys?.length ? '.' : ''}${key}=${encodeURIComponent(item[key].join(','))}`);
        } else if (item[key] instanceof Object) {
            result.push(...getKey(item[key], [...keys, key]));
        } else if (item[key] !== null && item[key] !== undefined && item[key] !== '') {
            result.push(
                `${keys.join('.')}${keys?.length ? '.' : ''}${key}=${encodeURIComponent(String(item[key]).trim())}`
            );
        }
    }

    return result;
}
